/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.session.SuspendPolicy
*/
export var SuspendPolicy;
(function (SuspendPolicy) {
    SuspendPolicy["KEEP"] = "KEEP";
    SuspendPolicy["CLOSE"] = "CLOSE";
})(SuspendPolicy || (SuspendPolicy = {}));
//# sourceMappingURL=SuspendPolicy.js.map